import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name"];
import { Block } from 'react-login-page';
import { jsx as _jsx } from "react/jsx-runtime";
export var Logo = props => {
  var {
      keyname,
      name = 'logo'
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  var key = keyname || name;
  if (!elmProps.children) {
    elmProps.children = '⚛️';
  }
  return /*#__PURE__*/_jsx(Block, _extends({}, elmProps, {
    keyname: key
  }));
};
Logo.displayName = 'Login.Logo';